// بهینه شده با کرسر

import React from "react";
import { Accordion } from "react-bootstrap";
import { CapitalizeAllWords  } from "../Functions/TextTransform";
import { useSelector } from "react-redux";
import { imgUrl } from "../config/api";
import {
  FA_BOTTOM_BAR_STYLE,
  FA_BRACKET_COLOR,
  FA_BRACKET_TYPE,
  FA_CONTROL_POSITION,
  FA_FEATURES,
  FA_GROMMET_FINISH,
  FA_HARDWARE_OPTION,
  FA_HEADER_STYLE,
  FA_HEM_STYLE,
  FA_LINING,
  FA_METAL_VALANCE_COLOR,
  FA_PANEL_COVERAGE,
  FA_PANEL_TYPE,
  FA_ROLL_TYPE,
} from "./draperyConstants";
import {
  FabricsSectionTitle,
  faOrEn,
  formatCombinedOutsideMountLabel,
  formatFaNumber,
  formatMotorChannels,
  isDraperySewingModel,
  normalizeOutsideMountSubType,
} from "./draperyUi";
import { DkCheckoutFabricDetails } from "./DkSideCartFabricDisplay";

// Cart items reach this component from different sources: guest localStorage keeps
// PreorderText on the item itself, while the logged-in cart API wraps it in SewingOrder.
const normalizeCartItem = (item) => {
  if (!item) {
    return { PreorderText: {} };
  }
  if (item.PreorderText) {
    return item;
  }
  if (item.SewingOrder) {
    return {
      ...item.SewingOrder,
      ...item,
      PreorderText: item.SewingOrder.PreorderText || {},
    };
  }
  return { ...item, PreorderText: {} };
};

const shouldShow0325DisplayField = (preorderText, fieldKey) => {
  if (!preorderText || preorderText.SewingModelId !== "0325") {
    return true;
  }
  const fieldConditions = {
    RollType: { Headrail: "Exposed" },
    BracketType: { Headrail: "Exposed"},
    BracketColor: { Headrail: "Exposed"},
    BottomBarStyle: { HemStyle: "Straight"},
  };
  const conditions = fieldConditions[fieldKey];
  if (!conditions) {
    return true;
  }
  return Object.keys(conditions).every(
    (conditionKey) => preorderText[conditionKey] === conditions[conditionKey]
  );
};

export default function DraperyComponent({
  drapery,
  pageLanguage,
  NumberToPersianWord,
  convertToPersian,
  t,
  GetPrice,
  isTabletOrMobile,
  ContextAwareToggleViewDetails,
  capitalizeFirstLetter,
}) {
  const { isLoggedIn } = useSelector((state) => state.auth);
  return (
    <div>
      <>
        {drapery &&
          [...drapery]
            ?.reverse()
            .filter((item) => item && item.TypeId !== 6402)
            .map(normalizeCartItem)
            .map((product, i) => (
              <li className="checkout_item_container" key={i}>
                <div className="checkout_item_image_container">
                  {product.ProductId ? (
                    <img
                      src={imgUrl(product.PhotoUrl)}
                      alt={product.ProductName}
                      className="checkout_item_img"
                    />
                  ) : (
                    <img
                      src={imgUrl(product.PreorderText.PhotoUrl)}
                      alt=""
                      className="checkout_item_img"
                    />
                  )}

                  <p className="checkout_item_image_qty 3">
                    {pageLanguage === "fa"
                      ? NumberToPersianWord.convertEnToPe(
                          `${product.Count || product.PreorderText.Count}`
                        )
                      : product.Count || product.PreorderText.Count}
                  </p>
                </div>
             
                <div
               className={`checkout_item_desc_container checkout_item_container_shades 2 ${
                     product.ProductId ? "checkout_item_container_shades_products"
              : ""
             }`}
             >
                  <div className="checkout_item 1">
                    <h1 className="checkout_item_name">
                    <p style={{display: "flex"}}>
                    {product.ProductId && (
                        <>
                          <p>
                          {pageLanguage === "fa"
                            ? product.ProductName
                            : product.ProductENName || product.ProductEnName}
                          </p>
                            {(product.ProductGroupId === "100203" ||
                        product.ProductGroupId === "100204" || 
                        product.ProductGroupId === "100201" || 
                        product.ProductGroupId === "100202" ||
                        product.ProductGroupId === "100205" ) && (
                        <p style={{ padding: "0 0.3rem" }}>
                           {pageLanguage === "fa" ? product.SewingModelName : CapitalizeAllWords(product.SewingModelEnName)} 
                        </p>
                      )}
                        </>
                      )}
                    </p>
                      {(product?.FabricId ||
                        product?.FabricId2 ||
                        product?.PreorderText?.FabricId ||
                        product?.PreorderText?.FabricId2) && (
                        <>
                          {pageLanguage === "fa"
                            ? convertToPersian(
                                product.PreorderText.ModelNameFa || product.ModelNameFa
                              ) + " سفارشی "
                            : "Custom " + product.PreorderText.ModelNameEn || product.ModelNameEn}
                        </>
                      )}
                    </h1>

                    <div className="checkout_item_price_section 1">
                      {product?.PayableAmount &&
                      product?.PayableAmount !== (product?.Price || product?.Amount) ? (
                        <>
                          <span
                            className="checkout_item_price checkout_item_price_with_discount"
                            style={{
                              textDecoration: "line-through",
                            }}
                          >
                            {GetPrice(
                              (product?.Price || product?.Amount) * product.Count,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </span>
                          <span className="checkout_item_price" style={{ color: "#ca6667" }}>
                            {GetPrice(
                              product.PayableAmount * product.Count,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </span>
                        </>
                      ) : product?.Price &&
                        product?.DiscountedPrice &&
                        product?.Price !== product?.DiscountedPrice ? (
                        <>
                          <span
                            className="checkout_item_price checkout_item_price_with_discount"
                            style={{
                              textDecoration: "line-through",
                            }}
                          >
                            {GetPrice(
                              product.Price * product.Count,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </span>
                          <span className="checkout_item_price" style={{ color: "#ca6667" }}>
                            {GetPrice(
                              product.DiscountedPrice * product.Count,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </span>
                        </>
                      ) : (
                        <span className="checkout_item_price">
                          {GetPrice(
                            (product?.Price || product?.Amount) *
                              (product.Count || product.PreorderText.Count),
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                  {!product.ProductId && (
                    <h4 className="checkout_item_room_name 2">
                      {pageLanguage === "fa"
                        ? (product.RoomNameFa || product.PreorderText.RoomNameFa) +
                          " / " +
                          product.PreorderText.WindowDescription
                        : (product.RoomNameEn || product.PreorderText.RoomNameEn) +
                          " / " +
                          product.PreorderText.WindowDescription}
                    </h4>
                  )}
                  <>
                    {product.ProductId ? (
                      <>
                        <h4
                          className="checkout_item_room_name 1"
                          style={{ padding: "0.1rem 0" }}
                        ></h4>
                        <Accordion>
                          <Accordion.Item eventKey="0">
                            <ContextAwareToggleViewDetails
                              eventKey="0"
                              textOnHide={t("View Details")}
                              textOnShow={t("Hide Details")}
                            />
                            <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                              <div className="basket_item_title_container 12">
                                <>
                                  <span className="checkout_item_discount checkout_item_details_color">
                                    <span>{t("Color: ")}</span>
                                    {pageLanguage === "fa"
                                      ? product.ColorName
                                      : product.ColorEnName}
                                  </span>
                                  {product.ProductSizeName &&
                                    product["ProductGroupId"] !== "100701" &&
                                    product["ProductGroupId"] !== "100702" && (
                                      <h2 className="checkout_item_details checkout_item_details_design">
                                        <span>{t("Size: ")}</span>
                                        {pageLanguage === "fa"
                                          ? convertToPersian(product.ProductSizeName)
                                          : product.ProductSizeEnName}
                                      </h2>
                                    )}

                                  {!product.ProductSizeName &&
                                    (product.Length  || product.len) &&
                                    product.ProductGroupId !== "500204" && (
                                      <h2 className="checkout_item_details checkout_item_details_design">
                                        <span>
                                          {pageLanguage === "fa" ? "طول: " : "Length: "}
                                          &nbsp;
                                        </span>
                                        {pageLanguage === "fa" ? product.Length || product.len : product.Length || product.len}
                                        <span> {t("CM")}</span>
                                      </h2>
                                    )}
                                  {product.Diameter && (
                                    <h2 className="checkout_item_details checkout_item_details_design">
                                      <span>{t("Diameter: ")}</span>
                                      {pageLanguage === "fa" ? product.Diameter : product.Diameter}
                                      <span> {t("MM")}</span>
                                    </h2>
                                  )}
                                  {product.LiningTypeEnName != null &&
                          !["0303", "0324", "0325"].includes(product.SewingModelId) && (
                         <h2 className="checkout_item_details checkout_item_details_design">
                          <span>{t("Lining: ")}</span>
                           {pageLanguage === "fa" ? product.LiningTypeName : product.LiningTypeEnName}
                         </h2>
                         )}
                                {product.ControlPosition !== undefined && product.ControlPosition != null && (
                             <h2 className="checkout_item_details checkout_item_details_design">
                             <span>{t("Control Position: ")}</span>
                              {product.ControlPosition ? t("Right") : t("Left")}
                              </h2>
                                )}

                                </>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </>
                    ) : (
                      <>
                        <Accordion>
                          <Accordion.Item eventKey="0">
                            <ContextAwareToggleViewDetails
                              eventKey="0"
                              textOnHide={t("View Details")}
                              textOnShow={t("Hide Details")}
                            />
                            <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                              <div className="basket_item_title_container 22">
                                {product.PreorderText.SewingModelId === "0326" && (
                                  <DkCheckoutFabricDetails
                                    product={product}
                                    pageLanguage={pageLanguage}
                                    t={t}
                                  />
                                )}
                                {isDraperySewingModel(product.PreorderText.SewingModelId) && (
                                  <h1 className="cart_agree_item_fabrics_sorted_title">
                                    {t("General Details")}
                                  </h1>
                                )}
                                {product.PreorderText.MountPositionId &&
                                  product.PreorderText.SewingModelId !== "0099" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 1" : ""
                                      }`}
                                    >
                                      <p>{t("Mount Position")}</p>
                                      <span>
                                        {product.PreorderText.MountPositionId === 4801 && (
                                          <span>{t("Inside Mount")}</span>
                                        )}
                                        {product.PreorderText.MountPositionId === 4802 && (
                                          <span>
                                            {formatCombinedOutsideMountLabel(
                                              normalizeOutsideMountSubType(
                                                product.PreorderText?.IsWalled ?? product.IsWalled,
                                                product.installationLocation
                                              ),
                                              pageLanguage,
                                              t
                                            ) || t("Outside Mount")}
                                          </span>
                                        )}
                                        {product.PreorderText.MountPositionId === 4803 && (
                                          <span>{t("Moulding Mount")}</span>
                                        )}
                                      </span>
                                    </div>
                                  )}

                                {product.PreorderText.MountPositionId &&
                                  isDraperySewingModel(product.PreorderText.SewingModelId) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 2" : ""
                                      }`}
                                    >
                                      <p>{t("Mount Position")}</p>
                                      <span>
                                        {product.PreorderText.MountPositionId === 4801 && (
                                          <span>{t("Ceiling")}</span>
                                        )}
                                        {product.PreorderText.MountPositionId === 4802 && (
                                          <span>{t("Wall")}</span>
                                        )}
                                        {product.PreorderText.MountPositionId === 4803 && (
                                          <span>{t("Moulding")}</span>
                                        )}
                                      </span>
                                    </div>
                                  )}
                                {product.PreorderText.CurtainPositionId &&
                                  isDraperySewingModel(product.PreorderText.SewingModelId) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 3" : ""
                                      }`}
                                    >
                                      <p>{t("Curtain Position")}</p>
                                      <span>
                                        {product.PreorderText.CurtainPositionId === 4901 && (
                                          <span>{t("Standard")}</span>
                                        )}
                                        {product.PreorderText.CurtainPositionId === 4902 && (
                                          <span>{t("Wall To Wall")}</span>
                                        )}
                                        {product.PreorderText.CurtainPositionId === 4903 && (
                                          <span>{t("Right Corner Window")}</span>
                                        )}
                                        {product.PreorderText.CurtainPositionId === 4904 && (
                                          <span>{t("Left Corner Window")}</span>
                                        )}
                                      </span>
                                    </div>
                                  )}
                                {product.PreorderText.WindowWidth && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 4" : ""
                                    }`}
                                  >
                                    <p>{t("WIDTH")}</p>
                                    <span>
                                      {pageLanguage === "fa" ? (
                                        <>
                                          {formatFaNumber(
                                            product.PreorderText.WindowWidth
                                          )}
                                        </>
                                      ) : (
                                        <>{product.PreorderText.WindowWidth}</>
                                      )}
                                      <>{t("cm")}</>
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.WindowHeight && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 5" : ""
                                    }`}
                                  >
                                    <p>{t("Height")}</p>
                                    <span>
                                      {pageLanguage === "fa" ? (
                                        <>
                                          {formatFaNumber(
                                            product.PreorderText.WindowHeight
                                          )}
                                        </>
                                      ) : (
                                        <>{product.PreorderText.WindowHeight}</>
                                      )}
                                      <>{t("cm")}</>
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.FinishedLengthTypeId &&
                                  isDraperySewingModel(product.PreorderText.SewingModelId) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 6" : ""
                                      }`}
                                    >
                                      <p>{t("Curtain Position")}</p>
                                      <span>
                                        {product.PreorderText.FinishedLengthTypeId === 5401 && (
                                          <span>{t("Sill")}</span>
                                        )}
                                        {product.PreorderText.FinishedLengthTypeId === 5402 && (
                                          <span>{t("Apron")}</span>
                                        )}
                                        {product.PreorderText.FinishedLengthTypeId === 5403 && (
                                          <span>{t("Floor")}</span>
                                        )}
                                        {product.PreorderText.FinishedLengthTypeId === 5404 && (
                                          <span>{t("Slight Puddle")}</span>
                                        )}
                                      </span>
                                    </div>
                                  )}
                                {isDraperySewingModel(product.PreorderText.SewingModelId) &&
                                  (product.PreorderText.FabricDesignEn ||
                                    product.FabricDesignEn) && (
                                    <FabricsSectionTitle title={t("Drapery")} />
                                  )}

                                {product.PreorderText.FabricDesignEn &&
                                  isDraperySewingModel(product.PreorderText.SewingModelId) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 7" : ""
                                      }`}
                                    >
                                      <p>{t("Fabric & Color")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? product.PreorderText.FabricDesignFa +
                                            "/" +
                                            product.PreorderText.FabricColorFa
                                          : capitalizeFirstLetter(
                                              product.PreorderText.FabricDesignEn
                                            ) +
                                            "/" +
                                            capitalizeFirstLetter(product.PreorderText.FabricColorEn)}
                                      </span>
                                    </div>
                                  )}
                                {product.BorderOrTrimDesignEn && isLoggedIn && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 8" : ""
                                    }`}
                                  >
                                    <p>{t("Decorative Border")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? `${product.BorderOrTrimDesignFa}/${
                                            product.BorderOrTrimColorFa
                                          }/${
                                            product.borderPosition === "60cm bottom border"
                                              ? "حاشیه۶۰ سانتی پایین"
                                              : product.borderPosition
                                          }`
                                        : `${product.BorderOrTrimDesignEn}/${product.BorderOrTrimColorEn}/${product.borderPosition}`}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.BorderOrTrimDesignEn && !isLoggedIn && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 9" : ""
                                    }`}
                                  >
                                    <p>{t("Decorative Border")}</p>

                                    <span>
                                      {pageLanguage === "fa"
                                        ? `${product.PreorderText.BorderOrTrimDesignFa}/${product.PreorderText.BorderOrTrimColorFa}`
                                        : `${product.PreorderText.BorderOrTrimDesignEn}/${product.PreorderText.BorderOrTrimColorEn}`}

                                      {t(product["PreorderText"]["borderPosition"])
                                        ? `/${t(product["PreorderText"]["borderPosition"])}`
                                        : ""}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.Lining && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 10" : ""
                                    }`}
                                  >
                                    <p>{t("Lining")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_LINING, product.PreorderText.Lining)}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.PanelCoverage &&
                                  (product.PreorderText.FabricDesignEn ||
                                    product.FabricDesignEn) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 11" : ""
                                      }`}
                                    >
                                      <p>{t("Panel Coverage")}</p>
                                      <span>
                                        {faOrEn(
                                          pageLanguage,
                                          FA_PANEL_COVERAGE,
                                          product.PreorderText.PanelCoverage
                                        )}
                                      </span>
                                    </div>
                                  )}
                                {product.PreorderText.PanelTypeA && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 12" : ""
                                    }`}
                                  >
                                    <p>{t("Panel Type")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_PANEL_TYPE, product.PreorderText.PanelTypeA)}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.GrommetFinish &&
                                  (product.PreorderText.FabricDesignEn ||
                                    product.FabricDesignEn) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 13" : ""
                                      }`}
                                    >
                                      <p>{t("Grommet Finish")}</p>
                                      <span>
                                        {faOrEn(
                                          pageLanguage,
                                          FA_GROMMET_FINISH,
                                          product.PreorderText.GrommetFinish
                                        )}
                                      </span>
                                    </div>
                                  )}
                                {product.PreorderText.hardwareDrapery &&
                                  product.hardwareDrapery !== "None" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 14" : ""
                                      }`}
                                    >
                                      <p>{t("Hardware")}</p>
                                      <span>
                                        {faOrEn(
                                          pageLanguage,
                                          FA_HARDWARE_OPTION,
                                          product.PreorderText.hardwareDrapery
                                        )}
                                      </span>
                                    </div>
                                  )}

                                {(product.DraperyHardware ||
                                  product.RailDesignFaA ||
                                  product.RailColorFaA ||
                                  product.BatonOptionA) &&
                                  product.DraperyHardware !== "None" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 15" : ""
                                      }`}
                                    >
                                      <p>{t("Hardware")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? FA_HARDWARE_OPTION[product.DraperyHardware] ||
                                            (product.DraperyHardware === "Rod"
                                              ? "میله پردهِ"
                                              : product.DraperyHardware === "Ring"
                                              ? "رینگ"
                                              : product.DraperyHardware) +
                                              "/" +
                                              product.RailDesignFaA +
                                              "/" +
                                              product.RailColorFaA +
                                              "/" +
                                              (product.BatonOptionA === "None"
                                                ? ""
                                                : product.BatonOptionA === "Baton 45cm"
                                                ? "باتون ۴۵ س‌م"
                                                : product.BatonOptionA === "Baton 30cm"
                                                ? "باتون ۳۰ س‌م"
                                                : product.BatonOptionA)
                                          : product.DraperyHardware +
                                            "/" +
                                            product.RailDesignEnA +
                                            "/" +
                                            product.RailColorEnA +
                                            "/" +
                                            product.BatonOptionA}
                                      </span>
                                    </div>
                                  )}
                                {product.PreorderText.HandCurtainNum &&
                                  product.PreorderText.SewingModelId !== "0325" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 16" : ""
                                      }`}
                                    >
                                      <p>{t("Matching Tieback")}</p>

                                      <span>
                                        {pageLanguage === "fa"
                                          ? `تعداد ${formatFaNumber(
                                              product.PreorderText.HandCurtainNum
                                            )}`
                                          : `Qty ${product.PreorderText.HandCurtainNum}`}
                                      </span>
                                    </div>
                                  )}

                                {isDraperySewingModel(product.PreorderText.SewingModelId) &&
                                  (product.PreorderText.MountPositionId !== 4801 ||
                                    product.MountPositionId === 4801) &&
                                  (product.PreorderText.FabricDesignEn2 ||
                                    product.FabricDesignEn2) && (
                                    <FabricsSectionTitle title={t("Sheer")} />
                                  )}
                                  {product.PreorderText.FabricDesignEn2 && product.PreorderText.FabricDesignEn2 !== null && product.PreorderText.FabricDesignEn2 !== undefined && 
                                    isDraperySewingModel(product.PreorderText.SewingModelId) &&
                                  product.PreorderText.MountPositionId !== 4801 && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 17" : ""
                                      }`}
                                    >
                                      <p>{t("Fabric & Color")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? product.PreorderText.FabricDesignFa2 +
                                            "/" +
                                            product.PreorderText.FabricColorFa2
                                          : capitalizeFirstLetter(
                                              product.PreorderText.FabricDesignEn2
                                            ) +
                                            "/" +
                                            product.PreorderText.FabricColorEn2}
                                      </span>
                                    </div>
                                  )}
                                {product.FabricDesignEn2 && product.FabricDesignEn2 !== null && product.FabricDesignEn2 !== undefined && 
                                  isDraperySewingModel(product.PreorderText.SewingModelId) &&
                                  product.MountPositionId === 4801 && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 18" : ""
                                      }`}
                                    >
                                      <p>{t("Fabric & Color")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? product.FabricDesignFa2 + "/" + product.FabricColorFa2
                                          : capitalizeFirstLetter(product.FabricDesignEn2) +
                                            "/" +
                                            product.FabricColorEn2}
                                      </span>
                                    </div>
                                  )}
                                  
                                {product.PreorderText.SheerHeaderStyle && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 19" : ""
                                    }`}
                                  >
                                    <p>{t("Header Style")}</p>
                                    <span>
                                      {faOrEn(
                                        pageLanguage,
                                        FA_HEADER_STYLE,
                                        product.PreorderText.SheerHeaderStyle
                                      )}
                                    </span>
                                  </div>
                                )}
                               
                                {product.PreorderText.PanelTypeB && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 20" : ""
                                    }`}
                                  >
                                    <p>{t("Panel Type")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_PANEL_TYPE, product.PreorderText.PanelTypeB)}
                                    </span>
                                  </div>
                                )}

                                {product.SheerHardware &&
                                  product.RailDesignEnB &&
                                  product.SheerHardware !== "None" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 21" : ""
                                      }`}
                                    >
                                      <p>{t("Hardware")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? FA_HARDWARE_OPTION[product.SheerHardware] ||
                                            [
                                              product.SheerHardware === "Track"
                                                ? "تراک"
                                                : product.SheerHardware === "Rod"
                                                ? "میله پردهِ"
                                                : null,
                                              product.RailDesignFaB,
                                              product.RailColorFaB,
                                              product.BatonOptionB === "Baton 30cm"
                                                ? "باتون ۳۰ س‌م"
                                                : product.BatonOptionB === "Baton 50cm"
                                                ? "باتون ۵۰ س‌م"
                                                : product.BatonOptionB === "None"
                                                ? ""
                                                : product.BatonOptionB,
                                            ]
                                              .filter(
                                                (value) => value !== null && value !== undefined
                                              ) // حذف مقادیر نامعتبر
                                              .join(" / ")
                                          : [
                                              product.SheerHardware,
                                              product.RailDesignEnB,
                                              product.RailColorEnB,
                                              product.BatonOptionB,
                                            ]
                                              .filter(
                                                (value) => value !== null && value !== undefined
                                              ) // حذف مقادیر نامعتبر
                                              .join(" / ")}
                                      </span>
                                    </div>
                                  )}
                                {product.PreorderText.hardwareSheer &&
                                  product.PreorderText.hardwareSheer !== "None" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 22" : ""
                                      }`}
                                    >
                                      <p>{t("Hardware")}</p>
                                      <span>
                                        {faOrEn(
                                          pageLanguage,
                                          FA_HARDWARE_OPTION,
                                          product.PreorderText.hardwareSheer
                                        )}
                                      </span>
                                    </div>
                                  )}

                                {product.PreorderText.HandCurtainNum2 && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 23" : ""
                                    }`}
                                  >
                                    <p>{t("Matching Tieback")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? `تعداد ${formatFaNumber(
                                            product.PreorderText.HandCurtainNum2
                                          )}`
                                        : `Qty ${product.PreorderText.HandCurtainNum2}`}
                                    </span>
                                  </div>
                                )}
                                {product.MotorPositionB && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 24" : ""
                                    }`}
                                  >
                                    <p>{t("Motor Position")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.MotorPositionB === "Right"
                                          ? "راست"
                                          : product.MotorPositionB === "Left"
                                          ? "چپ"
                                          : product.MotorPositionB
                                        : product.MotorPositionB}
                                    </span>
                                  </div>
                                )}
                                {product.RemoteNameB && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 25" : ""
                                    }`}
                                  >
                                    <p>{t("Remote Name")}</p>
                                    <span>{product.RemoteNameB}</span>
                                  </div>
                                )}
                                {product.MotorChannelsB && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 26" : ""
                                    }`}
                                  >
                                    <p>{t("Motor Channels")}</p>
                                    <span>
                                      {formatMotorChannels(product.MotorChannelsB, pageLanguage)}
                                    </span>
                                  </div>
                                )}

                                {product.hasLead && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 27" : ""
                                    }`}
                                  >
                                    <p>{t("Lead Weight")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.hasLead === "Included"
                                          ? "دارد"
                                          : product.hasLead === "True"
                                          ? "دارد"
                                          : product.hasLead === "Yes"
                                          ? "بله"
                                          : product.hasLead === "Left"
                                          ? "چپ"
                                          : product.hasLead
                                        : product.hasLead}
                                    </span>
                                  </div>
                                )}

                                {isDraperySewingModel(product.PreorderText.SewingModelId) &&
                                  (product.PreorderText.MountPositionId !== 4801 ||
                                    product.MountPositionId === 4801) &&
                                  (product.PreorderText.SheersDesignEn ||
                                    product.SheersDesignEn) && (
                                    <FabricsSectionTitle title={t("Privacy Layer")} />
                                  )}
                                {product.PreorderText.FabricDesignEn3 &&
                                  isDraperySewingModel(product.PreorderText.SewingModelId) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 28" : ""
                                      }`}
                                    >
                                      <p>{t("Fabric & Color")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? product.PreorderText.FabricDesignFa3 +
                                            "/" +
                                            product.PreorderText.FabricColorFa3
                                          : capitalizeFirstLetter(
                                              product.PreorderText.FabricDesignEn3
                                            ) +
                                            "/" +
                                            product.PreorderText.FabricColorEn3}
                                      </span>
                                    </div>
                                  )}

                                {product.SheersDesignEn &&
                                  isDraperySewingModel(product.PreorderText.SewingModelId) && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 29" : ""
                                      }`}
                                    >
                                      <p>{t("Fabric & Color")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? product.PreorderText.SheersDesignFa +
                                            "/" +
                                            product.PreorderText.SheersColorFa
                                          : capitalizeFirstLetter(
                                              product.PreorderText.SheersDesignEn
                                            ) +
                                            "/" +
                                            product.PreorderText.SheersColorEn}
                                      </span>
                                    </div>
                                  )}
                                {product.PrivacyLayerHeaderStyle && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 30" : ""
                                    }`}
                                  >
                                    <p>{t("Header Style")}</p>
                                    <span>
                                      {faOrEn(
                                        pageLanguage,
                                        FA_HEADER_STYLE,
                                        product.PrivacyLayerHeaderStyle
                                      )}
                                    </span>
                                  </div>
                                )}

                                {product.PreorderText.PanelTypeC && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 31" : ""
                                    }`}
                                  >
                                    <p>{t("Panel Type")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_PANEL_TYPE, product.PreorderText.PanelTypeC)}
                                    </span>
                                  </div>
                                )}

                                {product.hardwarePrivacyLayer &&
                                  product.hardwarePrivacyLayer !== "None" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 32" : ""
                                      }`}
                                    >
                                      <p>{t("Hardware")}</p>
                                      <span>
                                        {faOrEn(
                                          pageLanguage,
                                          FA_HARDWARE_OPTION,
                                          product.hardwarePrivacyLayer
                                        )}
                                      </span>
                                    </div>
                                  )}

                                {product.PrivacyLayerHardware &&
                                  product.SheersDesignEn &&
                                  product.PrivacyLayerHardware !== "None" && (
                                    <div
                                      className={`lable_Details ${
                                        pageLanguage === "fa" ? "lable_Details_rtl 33" : ""
                                      }`}
                                    >
                                      <p>{t("Hardware")}</p>
                                      <span>
                                        {pageLanguage === "fa"
                                          ? FA_HARDWARE_OPTION[product.PrivacyLayerHardware] ||
                                            [
                                              product?.PrivacyLayerHardware === "Rod"
                                                ? "میله پردهِ"
                                                : product?.PrivacyLayerHardware === "Track"
                                                ? "تراک"
                                                : product?.PrivacyLayerHardware,
                                              pageLanguage === "fa"
                                                ? product?.RailDesignFaC
                                                : product?.RailDesignEnC,
                                              pageLanguage === "fa"
                                                ? product?.RailColorFaC
                                                : product?.RailColorEnC,
                                              pageLanguage === "fa"
                                                ? product?.BatonOptionC === "Baton 45cm"
                                                  ? "باتون ۴۵ س‌م"
                                                  : product?.BatonOptionC === "Baton 30cm"
                                                  ? "باتون ۳۰ س‌م"
                                                  : product?.BatonOptionC !== "None" ? product?.BatonOptionC : ""
                                                : product?.BatonOptionC !== "None" ? product?.BatonOptionC : "",
                                            ]
                                              .filter(
                                                (value) => value !== null && value !== undefined && value !== "None" && value !== ""
                                              )
                                              .join(" / ")
                                          : [
                                              product?.PrivacyLayerHardware,
                                              product?.RailDesignEnC,
                                              product?.RailColorEnC,
                                              product?.BatonOptionC,
                                              product?.BatonOptionC !== null &&
                                              product?.BatonOptionC !== undefined
                                                ? product?.ControlPositionC
                                                : null, // حذف ControlPositionC اگر BatonOptionC نامعتبر باشد
                                            ]
                                              .filter(
                                                (value) => value !== null && value !== undefined
                                              ) // حذف مقادیر نامعتبر
                                              .join(" / ")}
                                      </span>
                                    </div>
                                  )}

                                {product.MotorPositionC && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 34" : ""
                                    }`}
                                  >
                                    <p>{t("Motor Position")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.MotorPositionC === "Right"
                                          ? "راست"
                                          : product.MotorPositionC === "Left"
                                          ? "چپ"
                                          : product.MotorPositionC
                                        : product.MotorPositionC}
                                    </span>
                                  </div>
                                )}
                                {product.RemoteNameC && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 35" : ""
                                    }`}
                                  >
                                    <p>{t("Remote Name")}</p>
                                    <span>{product.RemoteNameC}</span>
                                  </div>
                                )}
                                {product.MotorChannelsC && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 36" : ""
                                    }`}
                                  >
                                    <p>{t("Motor Channels")}</p>
                                    <span>
                                      {formatMotorChannels(product.MotorChannelsC, pageLanguage)}
                                    </span>
                                  </div>
                                )}
 
                                {isDraperySewingModel(product?.PreorderText?.SewingModelId) &&
                                  product?.PreorderText?.Accessories?.some(
                                    (accessory) => accessory?.DesignNameEn
                                  ) && (
                                    <FabricsSectionTitle title={t("Accessories")} />
                                  )}

                                {product.PreorderText.Accessories &&
                                  product.PreorderText.SewingModelId !== "0325" &&
                                  product.PreorderText.Accessories.map((accessory, index) => {
                                    if (!accessory.DesignNameEn) {
                                      // اگر DesignNameEn مقدار نداشت، چیزی برنگردان
                                      return null;
                                    }
                                    return (
                                      <div
                                        key={index}
                                        className={`lable_Details ${
                                          pageLanguage === "fa" ? "lable_Details_rtl 37" : ""
                                        }`}
                                      >
                                        <p>
                                          {pageLanguage === "fa"
                                            ? accessory.DesignNameFa
                                            : accessory.DesignNameEn}
                                        </p>
                                        <span>
                                          {pageLanguage === "fa"
                                            ? `تعداد ${formatFaNumber(
                                                accessory.Qty
                                              )}`
                                            : `Qty ${accessory.Qty}`}
                                        </span>
                                      </div>
                                    );
                                  })}

                                {product.PreorderText.ControlType && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 38" : ""
                                    }`}
                                  >
                                    <p>{t("Control Type")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.PreorderText.ControlType ===
                                          "Motorized / Standard"
                                          ? "برقی / استاندارد"
                                          : product.PreorderText.ControlType === "Continuous Loop"
                                          ? "دستی"
                                          : product.PreorderText.ControlType === "Chain & Cord"
                                          ? "بند و زنجیر"
                                          : product.PreorderText.ControlType === "Motorized"
                                          ? "برقی"
                                          : product.PreorderText.ControlType
                                        : product.PreorderText.ControlType}
                                    </span>
                                  </div>
                                )}
                                  {product.PreorderText.ControlPosition && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 44" : ""
                                    }`}
                                  >
                                    <p>{t("Control Position")}</p>
                                    <span>
                                      {faOrEn(
                                        pageLanguage,
                                        FA_CONTROL_POSITION,
                                        product.PreorderText.ControlPosition
                                      )}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.ChainLength && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 45" : ""
                                    }`}
                                  >
                                    <p>{t("Chain Length")}</p>
                                    <span>
                                      {pageLanguage === "fa" ? (
                                        <>
                                          {formatFaNumber(
                                            product.PreorderText.ChainLength
                                          )}
                                        </>
                                      ) : (
                                        <>{product.PreorderText.ChainLength}</>
                                      )}
                                      <>{t("cm")}</>
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.MotorPosition && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl  39" : ""
                                    }`}
                                  >
                                    <p>{t("Motor Position")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.PreorderText.MotorPosition === "Right"
                                          ? "راست"
                                          : product.PreorderText.MotorPosition === "Left"
                                          ? "چپ"
                                          : product.PreorderText.MotorPosition
                                        : product.PreorderText.MotorPosition}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.RemoteName && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 40" : ""
                                    }`}
                                  >
                                    <p>{t("Remote Name")}</p>
                                    <span>{product.PreorderText.RemoteName}</span>
                                  </div>
                                )}
                                {product.PreorderText.MotorChannels && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 41" : ""
                                    }`}
                                  >
                                    <p>{t("Motor Channels")}</p>
                                    <span>
                                      {formatMotorChannels(
                                        product.PreorderText.MotorChannels,
                                        pageLanguage
                                      )}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.MetalValanceStyle && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 42" : ""
                                    }`}
                                  >
                                    <p>{t("Metal Valance Style")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.PreorderText.MetalValanceStyle === "MetalValance"
                                          ? "قاب فلزی"
                                          : product.PreorderText.MetalValanceStyle ===
                                            "MetalValanceFabricInsert"
                                          ? "قاب فلزی با نمای پارچه ای"
                                          : product.PreorderText.MetalValanceStyle === "Left"
                                          ? "چپ"
                                          : t(product.PreorderText.MetalValanceStyle)
                                        : t(product.PreorderText.MetalValanceStyle)}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.MetalValanceColor && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 43" : ""
                                    }`}
                                  >
                                    <p>{t("Metal Valance Color")}</p>
                                    <span>
                                      {faOrEn(
                                        pageLanguage,
                                        FA_METAL_VALANCE_COLOR,
                                        product.PreorderText.MetalValanceColor
                                      )}
                                    </span>
                                  </div>
                                )}
                           
                                 {product?.PreorderText?.Headrail && <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 46" : ""
                                    }`}
                                  >
                                    <p>{t("Headrail")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_ROLL_TYPE, product.PreorderText.Headrail)}
                                    </span>
                                  </div>
                                }
                                {product.PreorderText.RollType &&
                                  shouldShow0325DisplayField(product.PreorderText, "RollType") && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 46" : ""
                                    }`}
                                  >
                                    <p>{t("Roll Type")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_ROLL_TYPE, product.PreorderText.RollType)}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.BracketType &&
                                  shouldShow0325DisplayField(product.PreorderText, "BracketType") && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 47" : ""
                                    }`}
                                  >
                                    <p>{t("Bracket Type")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_BRACKET_TYPE, product.PreorderText.BracketType)}
                                    </span>
                                  </div>
                                )}
                            
                                {product.PreorderText.BracketColor &&
                                  shouldShow0325DisplayField(product.PreorderText, "BracketColor") && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 48" : ""
                                    }`}
                                  >
                                    <p>{t("Bracket Color")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_BRACKET_COLOR, product.PreorderText.BracketColor)}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.HemStyle && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 49" : ""
                                    }`}
                                  >
                                    <p>{t("Hem Style")}</p>
                                    <span>
                                      {faOrEn(pageLanguage, FA_HEM_STYLE, product.PreorderText.HemStyle)}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.BottomBarStyle &&
                                  shouldShow0325DisplayField(
                                    product.PreorderText,
                                    "BottomBarStyle"
                                  ) && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 50" : ""
                                    }`}
                                  >
                                    <p>{t("Bottom Bar Style")}</p>
                                   
                                    <span>
                                      {faOrEn(
                                        pageLanguage,
                                        FA_BOTTOM_BAR_STYLE,
                                        product.PreorderText.BottomBarStyle
                                      )}
                                    </span>
                                  </div>
                                )}
                                {product.PreorderText.Features && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl 51" : ""
                                    }`}
                                  >
                                    <p>{t("Features")}</p>
                                    <span>
                                      {faOrEn(
                                        pageLanguage,
                                        FA_FEATURES,
                                        t(product.PreorderText.Features)
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </>
                    )}
                  </>

                  {product.DiscountEnName ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                      <img
                        src={require("../Images/public/discount1.svg").default}
                        className="img-fluid discount_applied_img"
                        alt=""
                      />
                      <span className="descount_price">
                        <span>
                          {pageLanguage === "fa" ? product.DiscountName : product.DiscountEnName}
                        </span>
                        <span style={{ padding: "0 2px" }}>
                          (
                          {GetPrice(
                            -((product.Price || product.Amount) - product.DiscountedPrice) *
                              product.Count,
                            pageLanguage,
                            t("T"),
                            isTabletOrMobile
                          )}
                          )
                        </span>
                      </span>
                    </div>
                  ) : (
                    product.Discount > 0 && (
                      <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        <img
                          src={require("../Images/public/discount1.svg").default}
                          className="img-fluid discount_applied_img"
                          alt=""
                        />
                        <span className="descount_price">
                          <span>
                            {pageLanguage === "fa"
                              ? product.DiscountCode || product.DiscountName
                              : product.DiscountCode || product.DiscountEnName}
                          </span>
                          <span style={{ padding: "0 2px" }}>
                            ({GetPrice(-product.Discount, pageLanguage, t("T"), isTabletOrMobile)})
                          </span>
                        </span>
                      </div>
                    )
                  )}
                </div>
              </li>
            ))}
      </>
    </div>
  );
}



